<template>
  <b-row>
    <!-- Columna 1 -->
    <b-col cols="12" md="6">
      <b-row class="mb-1 justify-content-center text-center">
        <b-col class="py-2 col-6">
          <b-img class="img-bm" :src="require('@/assets/images/pdf/logo_new.png')"/>
        </b-col>
        <b-col class="col-6 p-2 d-flex flex-column align-items-center">
            <b-avatar
              :src="avatar"
              class="p-0"
              size="14rem"
            />
              <b-avatar class="icon-network" variant="ligth">
                <b-img :src="getIconWhitePng('twitch')" :class="getIconColor('twitch')" fluid/>
              </b-avatar>
            <h2 class="text-capitalize text-underline">{{ data.basic.title }}</h2>
            <p class="text-muted-left-side-analytics">{{ getFormat(data.metrics.subscribers_count.value)}} {{ $t('search_preview.totalAudience') }}</p>
            <p class="text-muted-left-side-analytics mb-1" v-if="data.features && data.features.blogger_geo && data.features.blogger_geo.data">{{ data.features.blogger_geo.data.country }}</p>
         </b-col>

      </b-row>
      <b-row>
        <b-col>
          <div class="d-flex justify-content-between align-items-center mb-1">
          <p class="text-uppercase f-12">
            {{ $t(`search_preview.info_twitch.accountAnalysis`) }}
          </p>
        </div>

            <!-- Twitch grid analysis -->
        <div class="grid-analytics mb-2">
          <b-tooltip target="views-info">{{$t("search_preview.info_twitch.tooltipliveViews") }}</b-tooltip>
          <div class="grid-item box-style-analytics">
            <span class="text-muted-left-side-analytics">{{ $t("search_preview.info_twitch.averageLiveViews") }}
              <b-icon
                icon="question-circle"
                id="views-info"
                class="class-question"
              ></b-icon
            ></span>
            <span class="title-result">{{liveViewersAvg === 0 ? getFormat(liveViewersAvg) : $t('search_preview.notAvailable')}}</span>
          </div>

          <div class="grid-item box-style-analytics">
              <b-tooltip target="transmission-info">{{$t("search_preview.info_twitch.tooltiptransmission7d")}}</b-tooltip> 
            <span class="text-muted-left-side-analytics">{{ $t("search_preview.info_twitch.transmission7d")}}
              <b-icon
                icon="question-circle"
                id="transmission-info"
                class="class-question"
              ></b-icon
            ></span>
            <span class="title-result">{{ hoursStreamed }}</span>
          </div>

          <div class="grid-item box-style-analytics">
            <b-tooltip target="active-info">{{$t("search_preview.info_twitch.tooltipdaysActive")}}</b-tooltip>
            <span class="text-muted-left-side-analytics">{{ $t("search_preview.info_twitch.daysActive")}}
              <b-icon
                icon="question-circle"
                id="active-info"
                class="class-question"
              ></b-icon
            ></span>
            <span class="title-result">{{ activeDaysPerWeek }}</span>
          </div>

          <div class="grid-item box-style-analytics">
            <span class="text-muted-left-side-analytics">{{$t("search_preview.info_twitch.bestStreamingGame")}}</span>
            <span class="title-result">{{bestStreamingGame}}</span>
          </div>
        </div>

        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="card-resumen p-1 mb-1">
            <div class="icon-aling">
              <b-img :src="require(`@/assets/images/icons/stars.svg`)" class="icon-stars"></b-img>
            </div>
            <div>
              <span class="text-gray f-16">{{ $t(`search_preview.titleCard`)}}</span>
              <p class="text-gray avenir-medium mb-0"> 
                {{ $t(`search_preview.textCard`)}}
              </p>
            </div>
          </div>

        </b-col>
      </b-row>  
    </b-col>

    <!-- Columna 2 -->
    <b-col cols="12" md="6" class="background-small">
      <b-row class="m-1">
        <div class="box-style-analytics col-12">
          <div class="d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">

              <b-media vertical-align="center" class="d-flex align-items-center media-user-search">
                <template #aside>
                  <div class="position-relative w-100">
                    <b-avatar
                      size="md"
                      variant="light-primary"
                      class="main-avatar"
                      :src="avatar"
                    />
                      <b-avatar size="16px" class="container-avatar-table-icon" variant="light">
                        <b-img :src="getIconWhitePng('twitch')" :class="getIconColor('twitch', false)" fluid/>
                      </b-avatar>
                  </div>
                </template>
              </b-media>
            
              <h5 class="text-blue text-underline cursor-pointer f16 m-0 ml-05">@{{data.basic.username }}</h5>
            </div>
            
          </div>
        </div>
      </b-row>
      <b-row class="mb-2">
        <b-col
          v-for="(item, index) in image_content"
          cols="6"
          class="py-2"
          :key="update_image + '-' + index"
        >
          <b-card no-body class="size-card-animation">
            <div class="preview-container">
              <img
                :src="item.basic.animated_preview_url"
                alt="Preview"
                class="preview-image"
                @error="errorLoad(index)"
              />
            </div>

            <b-card-text class="p-2">
              <span class="text-title-overflow">
                {{ item.basic.title }}
              </span>
              <p class="mt-1 text-muted-left-side-analytics">
                <b-icon icon="eye" />
                {{ getFormat(item.metrics.views_count) }}
              </p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" v-if="!printing && !is_web" class="text-right">
          <b-button
            variant="primary"
            class="hide-sm"
            @click="print()"
          >
            {{$t('printSummary')}}
          </b-button>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol, BAvatar, BImg, BIcon, BTooltip, BMedia, BCard, BCardText, BButton } from 'bootstrap-vue'
import { print, getMotivationalPhrase } from '@/libs/utils/others';
import { getIconWhitePng, getIconColor } from "@/libs/utils/icons";
import { getFormat, urlImagetoBase64, getFormattedDateTime } from '@/libs/utils/formats';

export default {
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    avatar: {
      type: String,
      default: () => ''
    },
    format: {
      type: String,
      default: 'pdf'
    },
    is_web: {
      type: Boolean,
      default: false
    }
  },
  components: {
    BRow,
    BCol,
    BAvatar,
    BImg,
    BIcon,
    BTooltip,
    BMedia,
    BCard,
    BCardText,
    BButton
  },
  data () {
    return {
      getIconWhitePng,
      getIconColor,
      getMotivationalPhrase,
      urlImagetoBase64,
      getFormat,
      printing: false,
      print_image: require('@/assets/images/logo/logo_print.png'),
      src_img: '',
      interval_loading: null,
      image_content: [],
      update_image: false,
    }
  },
  created() {
    this.image_content = Object.values(this.data.features.last_media.data).slice(0, 4);

    const self = this;
    setTimeout(function() {
      self.showGraph = true;
      if (!self.is_web) self.print()
    }, 100);

    urlImagetoBase64(this.print_image, function (result) {
      self.src_img = result
    });
  },
  methods: {
    errorLoad(index) {
      this.image_content[index].basic.animated_preview_url = require('@/assets/images/dashboard/img-default-reload.svg');
      this.update_image = !this.update_image;
    },
    print() {
      const promises = this.image_content.map(image => {
        return new Promise(resolve => {
          this.urlImagetoBase64(image, base64 => {
            resolve({
              ...image,
              basic: {
                ...image.basic,
                animated_preview_url: base64
              }
            });
          });
        });
      });

      Promise.all(promises).then(base64Images => {
        this.contents = base64Images;
        console.log('new contents', this.contents)
      });
      this.printing = true;
      const self = this;
      const username = self.$route.params.alias ? self.$route.params.alias : this.data.basic.title
      this.$emit('toogleIconClose', true)
      const name_file = `BrandMe Resumen Metricas ${username} Twitch ${getFormattedDateTime()}`
      this.$vs.loading({
        type: 'sound',
        background: 'rgba(255, 255, 255, 1)',
        text: getMotivationalPhrase(),
      });

      this.interval_loading = setInterval(() => {
        const prev_loading = document.getElementsByClassName('con-vs-loading')[0]

        if (prev_loading) {
          prev_loading.classList.add('fade-out');
          setTimeout(function() {
            prev_loading.remove()
          }, 500);

          this.$vs.loading({
            type: 'sound',
            background: 'rgba(255, 255, 255, 1)',
            text: getMotivationalPhrase(),
          });
        }
      }, 5000);
      setTimeout(function() {
        print('l', name_file, self.$parent.$parent.$refs.body, function () {
          self.printing = false;
          clearInterval(self.interval_loading)
          self.$vs.loading.close()
          self.$emit('toogleIconClose', false)
          self.$emit('closeModal')
        }, self.format)
      }, 500);
    }
  },
  computed: {
    liveViewersAvg() {
      const val = this.data?.metrics?.live_viewers_avg?.performance?.["30d"]?.value;
      return val > 0 ? val : this.$t('search_preview.notAvailable');
    },

    hoursStreamed() {
      const val = this.data?.metrics?.hours_streamed?.performance?.["7d"]?.value;
      return val > 0 ? `${val} ${this.$t('profile.hours')}` : this.$t('search_preview.notAvailable');
    },

    activeDaysPerWeek() {
      const val = this.data?.metrics?.active_days_per_week?.performance?.["30d"]?.value;
      return val > 0 ? `${val} ${this.$t('twitter.days')}` : this.$t('search_preview.notAvailable');
    },

    bestStreamingGame() {
      const val = this.data?.features?.games?.top?.basic?.title;
      return val ? val : this.$t('search_preview.notAvailable');
    }
  }
}
</script>

<style scoped lang="scss">
.f-16 {
  font-size: 16px;
}
.icon-stars {
  width: 20px;
  height: 20px;
}
.icon-aling {
  align-content: space-around;
}
.card-resumen {
  background-color: rgba(65, 137, 230, .15);
  border-radius: 6px;
  display: flex;
  padding: 20px;
  border: 1px solid #E2E8F0;
  box-shadow: 0 1px 4px #0b14260a;
  gap:16px
}
  .img-bm {
    width: 100%;
    height: auto;
    max-width: 200px;
  }
  .icon-network {
    position: relative;
    width: 38px !important;
    height: 38px !important;
    left: 55px;
    bottom: 35px;
  }
  .grid-analytics {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
  @media (max-width: 690px) {
    grid-template-columns: repeat(1, 1fr);
  }
  .title-result {
    font-size: 20px;
    width: 100%;
    display: block;
  }
}
  .box-style-analytics {
    border-radius: 6px;
    box-shadow: 0 1px 4px #0b14260a;
    padding: 20px;
    background-color: white;
    border: 1px solid #E2E8F0;

    .f16 {
      font-size: 16px;
    }
    .grid-inner-box {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 10px;
      .inner-box {
        border: 1px solid #E2E8F0;
        border-radius: 6px;
        box-shadow: 0 1px 4px #0b14260a;
        padding: 16px;
      }
    }
    .outline-secondary-custom-analysis {
      background: white;
      box-shadow: rgba(0, 0, 0, 0.25) 0px 1px 4px;
      padding: 8px 5px;
      border-radius: 8px;
      .icon-external {
        font-size: 30px;
      }
    }
  }
  .ml-05 {
    margin-left: 0.5em;
  }
  .mr-05 {
    margin-right: 0.5em;
  }

  .text-muted-left-side-analytics {
    font-size: 16px;
    font-family: "avenir-medium";
    color: #718096;
    margin-bottom: 0.3em;
  }
  .class-question {
    cursor: pointer;
    margin-left: 10px;
  }
  .container-avatar-table-icon {
    position: absolute; 
    bottom: -2px; 
    right: 0;
  }
  .background-small {
    background-color: #F5F8FA;
    border-left: 1px solid #e2e8f0;
  }
  .size-card-animation {
    width: 250px;
    overflow: hidden;
    margin-right: 10px;
  }

  .preview-container {
    width: 100%;
    height: 140px;
    overflow: hidden;
    position: relative;
  }

  .preview-image {
    width: 100%;
    height: auto;
    display: block;
    object-fit: cover;
  }

  .text-title-overflow {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: normal;
  }
</style>
